import PropTypes from "prop-types";
import React, { useEffect } from "react";
import withRouter from "components/Common/withRouter";

// Layout Related Components
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import RightSidebar from "../CommonForBoth/RightSidebar";

const Layout = props => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const showRightSidebar = true;
  const leftSideBarType = "default";
  const leftSideBarTheme = "";

  const toggleMenuCallback = () => {
    // This toggles mobile sidebar visibility using 'sidebar-enable' class
    document.body.classList.toggle("sidebar-enable");

    // Optional: Toggle collapsed menu in desktop view
    if (window.innerWidth >= 992) {
      document.body.classList.toggle("vertical-collapsed");
    }
  };

  // Hide right sidebar if clicked outside
  const hideRightbar = event => {
    const rightbar = document.getElementById("right-bar");
    if (rightbar && rightbar.contains(event.target)) return;
    // Optional: Add logic to hide right sidebar
    document.body.classList.remove("right-bar-enabled");
  };

  useEffect(() => {
    // Add global click handler for right sidebar
    document.body.addEventListener("click", hideRightbar, true);

    // Cleanup on unmount
    return () => {
      document.body.removeEventListener("click", hideRightbar, true);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <React.Fragment>
      <div id="layout-wrapper">
        {/* ✅ Header with mobile sidebar toggle */}
        <Header toggleMenuCallback={toggleMenuCallback} />

        {/* ✅ Sidebar responds to toggle */}
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />

        {/* ✅ Main content area */}
        <div className="main-content mt-5 pt-3 pt-xl-0 mt-xl-0" style={{ minHeight: "100vh" }}>
          {props.children}
        </div>

        {/* Optional Footer */}
        {/* <Footer /> */}
      </div>

      {/* Right sidebar (if enabled) */}
      {showRightSidebar ? <RightSidebar /> : null}
    </React.Fragment>
  );
};

Layout.propTypes = {
  children: PropTypes.any,
};

export default withRouter(Layout);
